<template>
  <div id="app">
    <div class="top_div" id="video">
      <img class="home_banner" :src="bgImg" />
      <div class="div_top_title">
        <p>视频中心</p>
        <p class="p_title_sub">VIDEO CENTER</p>
      </div>
    </div>
    <div class="video_div">
      <div class="video_father">
        <div class="swiper-button-next">
          <img src="../../static/img/right.png" />
        </div>
        <div class="swiper-button-prev">
          <img src="../../static/img/left.png" />
        </div>
        <div
          style="
            --swiper-navigation-color: #fff;
            --swiper-pagination-color: #fff;
          "
          class="swiper-container mySwiper2"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in VideoList"
              :key="index"
            >
              <!-- <img :src="item.cover" /> -->
              <video
                style="width: 100%; object-fit: contain"
                :src="item.video"
                controls="controls"
                width="100%"
                :poster="item.cover"
              ></video>
            </div>
          </div>
        </div>
      </div>
      <div thumbsSlider="" class="swiper-container mySwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide myswiper-slide"
            v-for="(item, index) in VideoList"
            :key="index"
          >
            <img :src="item.cover" />
            <div class="play_div">
              <img src="../../static/img/play.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="download_div" id="download">
      <div class="div_mid_title">
        <p>下载中心</p>
        <p class="p_title_sub">DOWNLOAD CENTER</p>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-3 download_menu_div">
          <p class="download_title">文件类型</p>
          <div id="ul_header">
            <div
              class="download_menu"
              v-for="(item, index) in FileTypeList"
              :key="index"
              @click="getFilesByType(item)"
            >
              <p>{{ item.type }}</p>
            </div>
          </div>
          <div class="w3-dropdown-hover">
            <div class="dropdown">
              <button
                class="btn-default dropdown-toggle"
                type="button"
                id="dropdownMenu2"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ FilesTypeName }}
                <span class="caret"></span>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                <li
                  class="download_menu"
                  v-for="(item, index) in FileTypeList"
                  :key="index"
                  @click="getFilesByType(item)"
                >
                  <p>{{ item.type }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-9">
          <div class="download_title row phone_download_title">
            <div class="col-xs-8 col-sm-6 col-md-6">
              <p class="first_title">文件名</p>
            </div>
            <p class="col-xs-6 col-sm-2 col-md-2 download_mid_title">大小</p>
            <p class="col-xs-6 col-sm-2 col-md-2 download_mid_title">日期</p>
            <p class="col-xs-4 col-sm-2 col-md-2">下载</p>
          </div>
          <div v-for="(item, index) in FileList" :key="index">
            <div class="download_file">
              <div class="row">
                <div class="col-xs-8 col-sm-6 col-md-6 item">
                  <p class="first_p">{{ item.title }}</p>
                </div>
                <div class="col-xs-6 col-sm-2 col-md-2 item download_mid_title">
                  <p>{{ item.size }}</p>
                </div>
                <div class="col-xs-6 col-sm-2 col-md-2 item download_mid_title">
                  <p>{{ item.time }}</p>
                </div>
                <div class="col-xs-4 col-sm-2 col-md-2">
                  <div class="item_img">
                    <img
                      src="../../static/img/下载ICON.png"
                      @click="download(item.address)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination
        v-show="showFilePage"
        v-if="FileList.length !== 0"
        @handleCurrentChange="handleCurrentChange"
        :currentPage="currentPageNum"
        :total="total"
        :totalCount="totalCount"
      ></pagination>
    </div>
    <div class="news_div" id="news">
      <div class="div_news_title">
        <p>资讯中心</p>
        <p class="p_title_sub">INFORMATION CENTER</p>
      </div>
      <div>
        <div
          class="news_item"
          v-for="(item, index) in NewsList"
          :key="index"
          @click="NewsDetail(item.id)"
        >
          <img :src="item.cover" />
          <div style="width: 100%">
            <p class="news_title">{{ item.title }}</p>
            <p class="news_content">
              {{ item.simpleContent }}
            </p>
            <p class="news_time">{{ item.time }}</p>
          </div>
        </div>
      </div>
      <pagination
        v-show="showNewsPage"
        v-if="NewsList.length !== 0"
        @handleCurrentChange="handleCurrentChange2"
        :currentPage="currentPageNum2"
        :total="total2"
        :totalCount="totalCount2"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "./Pagination.vue";
// import pagination from "vue-pagination-bootstrap";
// import Pagination from 'vue-pagination-2';

export default {
  data() {
    return {
      showFilePage: false,
      showNewsPage: false,
      bgImg: "",
      path: "video",
      currentPageNum: 1,
      totalCount: 0,
      total: 2,
      currentPageNum2: 1,
      totalCount2: 0,
      total2: 2,
      FilesTypeName: "",
      NewsList: [
        {
          cover: "",
          time: "",
          title: "",
          simpleContent: "",
        },
      ],
      FileTypeList: [
        {
          id: "",
          type: "",
        },
      ],
      FileList: [
        {
          address: "",
          title: "",
          size: "",
          time: "",
        },
      ],
      VideoList: [
        {
          cover: "",
          title: "",
          video: "",
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.path);
      var param = this.$route.query.param;
      this.path = param;
      console.log("param:" + param);
      this.navtoPartPath(this.path);
    },
    VideoList() {
      this.$nextTick(() => {
        this.initBanner();
      });
    },
  },
  components: {
    Pagination,
  },
  mounted() {
    this.Init();
    var param = this.$route.query.param;
    this.path = param;
    console.log("param:" + param);
    this.navtoPartPath(this.path);
  },
  methods: {
    Init() {
      this.getBgImg();
      this.getNews();
      this.getFileType();
      this.getVideo();
      this.showMenuActive();
    },
    navtoPartPath(path) {
      setTimeout(() => {
        document.getElementById(path).scrollIntoView();
      }, 500);
    },
    pageChanged(page) {
      console.log(page);
      // Exec your response to server passing 'page' params as clicked button paging
    },
    initBanner() {
      var swiper = new Swiper(".mySwiper", {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });
      var swiper2 = new Swiper(".mySwiper2", {
        loop: false,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: swiper,
        },
      });
    },
    getBgImg() {
      let that = this;
      this.$axios
        .get("app/pagerimg/list")
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.bgImg = response.data.page.list[1].img;
            // console.log(that.bgImg);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getNews() {
      let that = this;
      this.$axios
        .get("app/newspager/list", {
          params: {
            page: that.currentPageNum2,
            limit: 5,
          },
        })
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.NewsList = response.data.page.list;
            that.totalCount2 = response.data.page.totalCount;
            that.total2 = response.data.page.totalPage;
            if (that.total2 > 1) {
              that.showNewsPage = true;
            } else {
              that.showNewsPage = false;
            }
            // console.log(that.NewsList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    NewsDetail(id) {
      // let routeData = this.$router.resolve({
      //   path: "/NewsDetail/id=" + id,
      // });
      // window.open(routeData.href, "_blank");
      this.$router.push("/NewsDetail/id=" + id);
    },
    getFileType() {
      let that = this;
      this.$axios
        .get("app/downloadtype/list")
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.FileTypeList = response.data.page.list;
            // console.log(that.FileTypeList);
            // sessionStorage.setItem("input", "null");
            that.FilesTypeName = that.FileTypeList[0].type;
            that.getFiles(that.FileTypeList[0].id);
          }
        })
        .catch((err) => console.log(err));
    },
    getFilesByType(item) {
      this.FilesTypeName = item.type;
      this.showMenuActive();
      this.currentPageNum = 1;
      this.getFiles(item.id);
    },
    getFiles(id) {
      // this.showMenuActive();
      let that = this;
      this.$axios
        .get("app/downloadpager/list/", {
          params: {
            typeId: id,
            page: that.currentPageNum,
            limit: 5,
          },
        })
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.FileList = response.data.page.list;
            that.totalCount = response.data.page.totalCount;
            that.total = response.data.page.totalPage;
            if (that.total > 1) {
              that.showFilePage = true;
            } else {
              that.showFilePage = false;
            }
            // console.log(that.FileList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    handleCurrentChange(data) {
      this.currentPageNum = data;
      console.log(data);
      this.getNews();
    },
    handleCurrentChange2(data) {
      this.currentPageNum2 = data;
      console.log(data);
      this.getNews();
    },
    getVideo() {
      let that = this;
      this.$axios
        .get("app/videopager/list")
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.VideoList = response.data.page.list;
            // console.log(that.VideoList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    download(url) {
      window.open(url);
    },
    showMenuActive() {
      console.log("showMenuActive");
      // $(document).on('click','#ul_header div',function(){
      //   console.log("#ul_header div");
      //   $("#ul_header div").removeClass("active");
      //   $(this).addClass("active");
      // })
      $("#ul_header div").click(function (e) {
        console.log("#ul_header div");
        $("#ul_header div").removeClass("active");
        $(this).addClass("active");
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.flex_container {
  display: flex;
  align-items: baseline;
  align-content: center;
}

.top_div {
  height: 100%;
  position: relative;
}

.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: #ec8938;

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.div_top_title {
  position: absolute;
  left: 20rem;
  bottom: 3rem;
  color: white;
  font-size: 3.6rem;
  font-family: medium;
  text-align: left;

  .p_title_sub {
    font-size: 4rem;
    line-height: 1;
    font-family: bin_num_din;
  }

  .litter_line_top {
    margin: 1rem auto 3rem;
    background-color: var(--textWhiteColor40);
    box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.4);
    height: 1px;
    width: 6%;
  }
}

.div_mid_title {
  color: var(--textBlueColor);
  font-size: 3.6rem;
  font-family: medium;
  text-align: left;
  margin-bottom: 3rem;

  .p_title_sub {
    font-size: 4rem;
    line-height: 1;
    font-family: bin_num_din;
  }
}

.div_news_title {
  color: var(--textBlueColor);
  font-size: 3.6rem;
  font-family: medium;
  text-align: left;

  .p_title_sub {
    font-size: 4rem;
    line-height: 1;
    font-family: bin_num_din;
  }
}

.video_div {
  margin: 1rem 20rem;
}

.video_father {
  position: relative;
  background: #e5e5e5;
  height: 40vw;
  padding: 3rem 0;
}

.download_div {
  margin: 5rem 20rem 0;
}

.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  position: relative;
  text-align: center;
  font-size: 18px;
  // background: #fff;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.play_div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  background: -webkit-linear-gradient(#00000099, #00000099); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#00000099, #00000099); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#00000099, #00000099); /* Firefox 3.6 - 15 */
  background: linear-gradient(#00000099, #00000099); /* 标准的语法（必须放在最后） */

  img {
    object-fit: cover;
    width: 6rem !important;
    height: 6rem !important;
  }
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-container {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
  height: 90%;
  width: 70%;
  top: 5%;
}

.swiper-button-next {
  // background:var(--textBlueColor);
  color: transparent;
  // height:10rem;
  // width:4rem;
  top: 50%;
  margin-right: 5%;
}

.swiper-button-prev {
  // background:var(--textBlueColor);
  color: transparent;
  // height:10rem;
  // width:4rem;
  top: 50%;
  margin-left: 5%;
}

.mySwiper {
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
}

.mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  // opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
  // opacity: 1;
  .play_div {
    border: 5px solid var(--textBlueColor);
    background: -webkit-linear-gradient(#00000000, #00000000); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(#00000000, #00000000); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(#00000000, #00000000); /* Firefox 3.6 - 15 */
    background: linear-gradient(#00000000, #00000000); /* 标准的语法（必须放在最后） */

    img {
      display: none;
    }
  }
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news_div {
  margin: 10rem 20rem;
}

.news_item {
  display: flex;
  border-bottom: 1px solid #5E5E5E;

  img {
    margin: 3rem 0;
    width: 42rem;
    height: 24rem;
  }

  div {
    margin: 3rem 0;
    padding-top: 3rem;
    padding-left: 5rem;
    position: relative;

    .news_title {
      color: black;
      font-size: 2.6rem;
      font-family: medium;
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .news_content {
      text-align: left;
      color: #AFAFAF;
      font-size: 1.6rem;
      font-family: light;
      margin-top: 3rem;
    }

    .news_time {
      color: #AFAFAF;
      font-size: 1.6rem;
      font-family: light;
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
}

.news_item:last-child {
  border: none;
}

.download_title {
  background-color: var(--textBlueColor);
  color: var(--textWhiteColor);
  font-size: 1.6rem;
  padding: 0.5rem 0;

  .first_title {
    width: fit-content;
    text-align: left;
    margin-left: 30%;
  }
}

.download_file {
  margin: 0 -1.5rem;
  color: #5E5E5E;
  background: white;
  border-bottom: 1px solid #5E5E5E;
  font-size: 1.6rem;
  font-family: cnlight;
  vertical-align: center;

  .item {
    height: 100%;
  }

  .item_img {
    height: 100%;
    line-height: 8rem;
  }

  .first_p {
    text-align: left;
    margin-left: 5rem;
  }

  p {
    line-height: 8rem;
    text-align: center;
    height: 8rem;
    vertical-align: center;
  }

  img {
    margin: 0;
    width: 2.6rem;
    height: 100%;
  }
}

.download_menu {
  height: 8rem;
  cursor: pointer;
  color: #5E5E5E;
  background: white;
  border-bottom: 1px solid #5E5E5E;
  // height: 7.6rem;
  font-size: 2rem;

  img {
    width: 2.6rem;
    height: 2.2rem;
  }

  p {
    height: 100%;
    line-height: 8rem;
  }
}

.w3-dropdown-hover {
  display: none;
}

.active {
  background: #EFEFEF;
}

.download_menu:hover {
  background: #EFEFEF;
}

@media screen and (max-width: 1200px) {
  .top_div {
    padding-top: 60px;
  }

  .home_banner {
    height: 20rem;
  }

  .div_top_title {
    left: 2rem;
    bottom: 1rem;
    font-size: 2.6rem;

    .p_title_sub {
      font-size: 3rem;
    }
  }

  .video_div {
    margin: 2rem;
  }

  .video_father {
    background: none;
    padding: 0;
    height: 60vw;
  }

  .swiper-button-next {
    display: none;
  }

  .swiper-button-prev {
    display: none;
  }

  .mySwiper2 {
    width: 100%;
    // height: 22rem;
  }

  .myswiper-slide {
    height: 10rem !important;
    width: 45% !important;
  }

  .download_div {
    margin: 5rem 2rem;
  }

  .div_mid_title {
    left: 2rem;
    bottom: 1rem;
    font-size: 2.6rem;
    margin-bottom: 1rem;

    .p_title_sub {
      font-size: 3rem;
    }
  }

  .download_menu_div {
    display: flex;
    margin: 0 0 2rem;

    .download_title {
      width: 15rem;
      padding: 1rem;
      height: 100%;
    }
  }

  .dropdown-menu {
    border-top: 2px solid var(--textBlueColor);
    border-left: 2px solid var(--textBlueColor);
    border-right: 2px solid var(--textBlueColor);
    border-radius: 0;
    padding: 0;
    width: 100%;
  }

  .download_menu {
    height: 5rem;
    font-size: 1.6rem;
    color: var(--textBlueColor);
    border-bottom: 2px solid var(--textBlueColor);

    p {
      line-height: 5rem;
    }
  }

  .btn-default {
    font-size: 1.6rem;
    color: var(--textBlueColor);
    width: 100%;
    border: none;
  }

  .btn-default:hover {
    color: var(--textBlueColor) !important;
    background: white !important;
  }

  .download_file {
    margin: 0;
  }

  .phone_download_title {
    margin: 0;
  }

  .w3-dropdown-hover {
    display: block;
    height: 100%;
    width: 100%;
    padding: 0.6rem;
    color: var(--textBlueColor);
    font-size: 1.6rem;
    margin-left: 1rem;
    border: 0.4rem solid var(--textBlueColor);
  }

  .dropdown_div {
    display: flex;
    align-items: center;
  }

  .w3-dropdown-content {
    position: inherit;
  }

  .w3-bar-item {
    text-align: center;
    color: var(--textBlueColor);
    font-size: 1.6rem;
  }

  .w3-button {
    padding: 1rem 0;
    width: 100%;
  }

  .w3-button-border {
    border-top: 3px solid var(--textBlueColor);
  }

  .download_mid_title {
    display: none;
  }

  .download_file {
    border-bottom: 3px solid var(--textBlueColor);

    .first_p {
      margin-left: 1rem;
    }

    p {
      line-height: 5rem;
      height: 5rem;
    }

    .item_img {
      margin-right: 2rem;
      line-height: 5rem;
    }
  }

  #ul_header {
    display: none;
  }

  .news_div {
    margin: 0 2rem;
  }

  .news_item {
    flex-direction: column;
    border-bottom: 1px solid #afafaf;

    img {
      width: 100%;
      height: auto;
      margin: 1rem 0;
    }

    div {
      margin: 0;
      padding: 1rem 0;

      .news_content {
        margin: 1rem;
      }
    }
  }
}
</style>
